export default {"src":"/_next/static/image/public/images/location_file.5e1960bfa30f31faee15f1054bd51ce7.svg","height":32,"width":32};